import React from "react";
import { Box, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning"; // Use MUI icon

interface HostCardPendingApprovalOverlayProps {
  fullWidth?: boolean; // optional prop if you want overlay to stretch
}

const HostCardPendingApprovalOverlay: React.FC<HostCardPendingApprovalOverlayProps> = ({
  fullWidth = false,
}) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: fullWidth ? "100%" : "90%",
        height: "100%",
        bgcolor: "rgba(0, 0, 0, 0.6)",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        p: 2,
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="white" mb={1} display="flex" alignItems="center" gap={1}>
        <WarningIcon fontSize="inherit" /> Pending Approval
      </Typography>
      <Typography variant="body1" color="white">
        This location is pending admin approval.
      </Typography>
    </Box>
  );
};

export default HostCardPendingApprovalOverlay;
